// Libs
import classNames from 'classnames/bind';
import { Box, Stack, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
// Styles, images, icons
import styles from './BaseVerticalTabItem.module.scss';
import { icons } from '~/assets';

type Props = {
  icon: string;
  label: string;
  value?: string;
  isActive?: boolean;
};

const cx = classNames.bind(styles);

const BaseVerticalTabItem = (props: Props) => {
  //#region Destructuring Props
  const { icon, label, value, isActive } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='verticalTabItemComponent' className={cx('verticalTabContainer')}>
      <Tab
        id='verticalTabItemComponent'
        value={value || EMPTY_STRING}
        label={
          <Stack
            direction={'row'}
            spacing={1}
            alignItems={'center'}
            justifyContent={'space-between'}
            style={{ width: '100%' }}
          >
            <Stack direction={'row'} spacing={1} alignItems={'center'} className={cx('labelGroup')}>
              <img src={icon} alt={t('common_alt_img', { ns: 'common/base' })} className={cx('tabIcon')} />

              <span className={cx('tabLabel')}>{label || EMPTY_STRING}</span>
            </Stack>

            <img
              src={icons.tabIconPlus}
              alt={t('common_alt_img', { ns: 'common/base' })}
              className={cx('tabIcon')}
            />
          </Stack>
        }
        className={cx('tabItem', { active: isActive })}
      />
    </Box>
  );
};

export default BaseVerticalTabItem;
